import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Reducer } from 'react';

export const init = (reducers: Record<string, Reducer<unknown, unknown>>) => {
  const rootReducer = combineReducers(reducers);
  const middlewareList = [thunk];
  const middleware = composeWithDevTools(applyMiddleware(...middlewareList));

  return createStore(rootReducer, middleware);
};
